const NAMED: Record<string, string> = {
  amp: "&",
  apos: "'",
  quot: '"',
  lt: "<",
  gt: ">",
  nbsp: " ",
  pound: "£",
};

/**
 * Decodes the HTML entities eBay leaves in message text (e.g. "I&apos;m"). Works without a DOM
 * so it can run anywhere; unknown entities are left untouched.
 */
export function decodeHtml(text: string | null | undefined) {
  if (!text) return "";

  return text.replace(/&(#x[0-9a-f]+|#[0-9]+|[a-z]+);/gi, (entity, code: string) => {
    if (code[0] === "#") {
      const point = code[1].toLowerCase() === "x" ? parseInt(code.slice(2), 16) : parseInt(code.slice(1), 10);
      return Number.isFinite(point) && point > 0 ? String.fromCodePoint(point) : entity;
    }
    return NAMED[code.toLowerCase()] ?? entity;
  });
}
